export default class MediaObject{
    constructor(){
        this.type="",
        this.fileName=""
        this.exifOrientation=0;
        this.thumbnail=""; //base64 data
        this.url="" //cdvfile://"; or base 64 data i guess or another internal url
    }
}
